<app-gc-header
  [titleString]="'changelogTitle' | translate"
  [iconName]="'penToSquare'"
/>

<div class="changelog-content">
  <gc-button
    [variant]="'plain'"
    [iconPosition]="'left'"
    [icon]="'chevronLeft'"
    (clicked)="goToHome()"
    >{{ 'backButtonText' | translate }}</gc-button
  >
  @for (entry of visibleEntries(); track $index) {
    <div class="changelog-entry-card">
      <app-changelog-entry-card [entry]="entry" />
    </div>
  }
</div>
